/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-30 16:13:57
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\layouts\UserLayout\locales\en-US.ts
 */
export default {
  'user-layout.menu.login': 'Login',
  'user-layout.menu.register': 'Register',
  'user-layout.menu.activation': 'Activation',
  'user-layout.menu.activationemail': 'Mailbox activation',
  'user-layout.menu.success': 'Success',
};
